var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "more vert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,8a2,2,0,1,0-2-2A1.99945,1.99945,0,0,0,12,8Zm0,2a2,2,0,1,0,2,2A1.99945,1.99945,0,0,0,12,10Zm0,6a2,2,0,1,0,2,2A1.99945,1.99945,0,0,0,12,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVert);
export default __webpack_public_path__ + "static/media/MoreVert.4e2ec76fad15d968e91d130e79a54441.svg";
export { ForwardRef as ReactComponent };